import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_COMPTET_XTMP_SCHEMA_LITERAL = {
    title: 'Schéma CompteTiers Tmp',
    description: 'CompteTiers Tmp',
    version: 1,
    keyCompression: false,
    primaryKey: 'CT_NUM_INTERNAL',
    type: 'object',
    properties: {
        MD_SITEGID : { type : 'string' },
        MD_SITE : { type : 'string' },
        MD_CAISSE : { type : 'string' },
        MD_CAISSE_LIB : { type : 'string' },
        MD_CAISSIERGID : { type : 'string' },
        MD_CAISSIER : { type : 'string' },
        MD_CAISSIER_LIB : { type : 'string' },
        MD_CAISSE_SESSION : { type : 'string' },
        MD_LOCALGID : { type : 'string' },
        MD_DATE_CREATION : { type : 'string' },
        CT_GID : { type : 'string' },
        CT_MODE : { type : 'string' }, // NEW | UPD
        CT_NUM : { type : ['string', 'null'] },
        CT_NUM_INTERNAL : { type : 'string', maxLength : 100 },
        CT_INTITULE : { type : 'string' },
        CT_CONTACT : { type : 'string' },
        CT_COMMENTAIRE : { type : 'string' },
        CT_ADRESSE : { type : 'string' },
        CT_COMPLEMENT : { type : 'string' },
        CT_CODEPOSTAL : { type : 'string' },
        CT_VILLE : { type : 'string' },
        CT_PAYS : { type : 'string' },
        CT_REGION : { type : 'string' },
        CT_TELEPHONE : { type : 'string' },
        CT_TELECOPIE : { type : 'string' },
        CT_EMAIL : { type : 'string' },
        CT_SITE : { type : 'string' },
        CT_LINKEDIN : { type : 'string' },
        CT_FACEBOOK : { type : 'string' },
        CT_SIRET : { type : 'string' },
        CT_APE : { type : 'string' },
        CT_IDENTIFIANT : { type : 'string' },
        CONTACT_ITEMS_JSON : { type : 'string' },
        ADRESSE_ITEMS_JSON : { type : 'string' },
        ZSYNCUP_FLAG  : { type : 'number', default : 0 },
        ZSYNCUP_STATUS  : { type : 'string' },
        ZSYNCUP_ERROR_MESSAGE  : { type : 'string' },
        ZSYNCUP_DATETIME  : { type : 'string' },
        ZSYNCUP_FEEDID  : { type : 'string' },
        ZCLIENT_STATUS : { type : 'number', default : 0 },
        CT_NUM_FROM  : { type : ['string', 'null'] }
    },
    required: [ 'CT_NUM_INTERNAL', 'CT_INTITULE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_COMPTET_XTMP_SCHEMA_LITERAL);
export type RxCluCompteTxTmpDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_COMPTET_XTMP_SCHEMA: RxJsonSchema<RxCluCompteTxTmpDocumentType> = CLU_COMPTET_XTMP_SCHEMA_LITERAL;
